module.exports = __webpack_public_path__ + "static/media/8851.c98db7b0.jpg";